const regionSelector = (data) => ({
    lastVisitRegion: window.Alpine.$persist(null),
    lastVisitCountry: window.Alpine.$persist(null),
    lastSelectedRegion: window.Alpine.$persist(null),
    selectedRegionIndex: null,
    showBanner: false,
    regions: data.regions || [],
    expectedRegion: null,
    currentRegion: null,
    getRegion: async () => {
        // Category and search pages have the region store (region.js), which has already asked
        const store = window.Alpine.store('region')
        if (store?.load) {
            return store.load()
        }

        const country = new URLSearchParams(window.location.search).get('CF-IPCountry')
        const params = country ? { 'CF-IPCountry': country } : {}
        const response = await window.api.get('/api/region', params)
        return response.data
    },
    openModal() {
        this.showBanner = false
        this.$refs.regionModal.showModal()
    },
    closeModal() {
        this.showBanner = true
        this.$refs.regionModal.close()
    },
    async init() {
        const regionData = await this.getRegion()

        this.regions = data.regions
            .filter((region) => region.app_region === regionData.app_region || region.app_region === regionData.expected_app_region)
            .sort((a, b) => (b.app_region === regionData.expected_app_region) - (a.app_region === regionData.expected_app_region))

        this.expectedRegion = this.regions.find((region) => region.app_region === regionData.expected_app_region)
        this.currentRegion = this.regions.find((region) => region.app_region === regionData.app_region)

        this.selectedRegionIndex = 0

        if (regionData.app_region !== regionData.expected_app_region && regionData.change_region) {
            if (this.lastVisitRegion !== regionData.app_region || this.lastVisitCountry !== regionData.geo_country_code) {
                this.openModal()
            } else {
                this.showBanner = true
            }
        }

        if (regionData.geo_country_code) {
            this.lastVisitCountry = regionData.geo_country_code
        }
        if (regionData.app_region) {
            this.lastVisitRegion = regionData.app_region
        }
    },
    selectRegion() {
        const region = this.regions[this.selectedRegionIndex]
        if (!region) {
            this.closeModal()
            return
        }
        if (region.app_region) {
            this.lastSelectedRegion = region.app_region
        }
        if (this.lastVisitRegion !== region.app_region) {
            window.location = region.link
        } else {
            this.closeModal()
        }
    },
})

document.addEventListener('alpine:init', () => {
    window.Alpine.data('regionSelector', regionSelector)
})

export default regionSelector
